export default "__VITE_ASSET__5a682500__"